/*! grapesjs-style-filter - 1.0.2 */
!function (e, t) {
  'object' == typeof exports && 'object' == typeof module ? module.exports = t() : 'function' == typeof define && define.amd ? define([], t) : 'object' == typeof exports ? exports["grapesjs-style-filter"] = t() : e["grapesjs-style-filter"] = t();
}('undefined' != typeof globalThis ? globalThis : 'undefined' != typeof window ? window : this, function () {
  return function () {
    "use strict";

    var e = {
      d: function d(t, r) {
        for (var n in r) {
          e.o(r, n) && !e.o(t, n) && Object.defineProperty(t, n, {
            enumerable: !0,
            get: r[n]
          });
        }
      },
      o: function o(e, t) {
        return Object.prototype.hasOwnProperty.call(e, t);
      },
      r: function r(e) {
        'undefined' != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
          value: 'Module'
        }), Object.defineProperty(e, '__esModule', {
          value: !0
        });
      }
    },
        t = {};
    e.r(t), e.d(t, {
      default: function _default() {
        return n;
      }
    });

    var r = void 0 && (void 0).__assign || function () {
      return r = Object.assign || function (e) {
        for (var t, r = 1, n = arguments.length; r < n; r++) {
          for (var o in t = arguments[r]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }

        return e;
      }, r.apply(this, arguments);
    };

    var n = function n(e) {
      e.Styles.addBuiltIn('filter', {
        type: 'stack',
        layerSeparator: ' ',
        fromStyle: function fromStyle(e, t) {
          var r = t.property,
              n = e[t.name] || '',
              o = r.getLayerSeparator();
          return n ? n.split(o).map(function (e) {
            var t = r.__parseFn(e);

            return {
              name: t.name,
              value: t.value
            };
          }) : [];
        },
        toStyle: function toStyle(e, t) {
          var r;
          return (r = {})[t.name] = "".concat(e.name, "(").concat(e.value, ")"), r;
        },
        properties: [{
          property: 'name',
          name: 'Type',
          type: 'select',
          default: 'sepia',
          full: !0,
          options: [{
            id: 'blur',
            propValue: {
              min: 0,
              units: ['px', 'em', 'rem', 'vw', 'vh']
            }
          }, {
            id: 'brightness',
            propValue: {
              min: 0,
              units: ['%']
            }
          }, {
            id: 'contrast',
            propValue: {
              min: 0,
              units: ['%']
            }
          }, {
            id: 'grayscale',
            propValue: {
              min: 0,
              max: 100,
              units: ['%']
            }
          }, {
            id: 'hue-rotate',
            propValue: {
              min: 0,
              max: 360,
              units: ['deg', 'rad', 'grad']
            }
          }, {
            id: 'invert',
            propValue: {
              min: 0,
              max: 100,
              units: ['%']
            }
          }, {
            id: 'saturate',
            propValue: {
              min: 0,
              units: ['%']
            }
          }, {
            id: 'sepia',
            propValue: {
              min: 0,
              max: 100,
              units: ['%']
            }
          }],
          onChange: function onChange(e) {
            var t = e.property;

            if (e.to.value) {
              var n = t.getOption(),
                  o = r({}, n.propValue || {}),
                  a = t.getParent().getProperty('value'),
                  i = a.getUnit();
              (!i || (null == o ? void 0 : o.units.indexOf(i)) < 0) && (o.unit = (null == o ? void 0 : o.units[0]) || ''), a.up(o);
            }
          }
        }, {
          property: 'value',
          type: 'slider',
          default: '0',
          full: !0
        }]
      });
    };

    return t;
  }();
});